'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';

const DraftDeleteModal = ({
  draftName,
  onConfirm,
  onReject
}) => /*#__PURE__*/_jsx(UIConfirmModal, {
  confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "campaigns.drafts.delete.confirmLabel"
  }),
  confirmUse: "danger",
  message: /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.drafts.delete.message"
    })
  }),
  description: /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "campaigns.drafts.delete.description",
      options: {
        draftName
      }
    })
  }),
  matcherLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "campaigns.drafts.delete.matcherLabel"
  }),
  match: I18n.text('campaigns.drafts.delete.match'),
  size: "auto",
  use: "danger",
  onConfirm: onConfirm,
  onReject: onReject,
  rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "cancelButton"
  })
});

export default DraftDeleteModal;